import React from "react";
import BlogPage from '../../../components/BlogPage';
import { Seo } from "../../../components/Seo";
import { blogThirtyFour } from "../../../constants/blogData/blogThirtyFour";

const BlogPageblogThirtyFour = () => {
  return (
    <BlogPage data={blogThirtyFour} />
  );
};

export default BlogPageblogThirtyFour;

export const Head = () => (
<Seo
  title="10 Best Restaurants in San Ramon You Should Try | Foodaholix"
  description="Discover 10 of the best restaurants in San Ramon that serve diverse and delicious cuisine from different regions and culture with Foodaholix"
  canonicalHref="https://foodaholix.com/blogs/best-10-restaurants-san-ramon"
/>
)
